const SITE_ENV =
  process.env.REACT_APP_SITE_ENV ||
  (process.env.NODE_ENV === 'development' ? 'development' : 'production');

const SITE_URL = (
  process.env.REACT_APP_SITE_URL || 'https://jtc.center'
).replace(/\/+$/, '');

const DEFAULT_ROBOTS_CONTENT =
  SITE_ENV === 'production' ? 'index,follow' : 'noindex,nofollow,noarchive';

const resolveRobotsContent = () => {
  if (SITE_ENV !== 'production') {
    return 'noindex,nofollow,noarchive';
  }

  return process.env.REACT_APP_ROBOTS_META || DEFAULT_ROBOTS_CONTENT;
};

const resolveContactFormMode = () => {
  if (SITE_ENV !== 'production') {
    return 'disabled';
  }

  return process.env.REACT_APP_CONTACT_FORM_MODE || 'production';
};

const parseCommaSeparatedValues = value =>
  (value || '')
    .split(',')
    .map(item => item.trim().toLowerCase())
    .filter(Boolean);

const parseAllowedDomains = value =>
  parseCommaSeparatedValues(value).map(domain => domain.replace(/^@+/, ''));

const STG_AUTH_ENABLED =
  SITE_ENV === 'stg' &&
  (process.env.REACT_APP_STG_AUTH_ENABLED || 'false').toLowerCase() === 'true';

export const ENVIRONMENT = {
  SITE_ENV,
  IS_PRODUCTION: SITE_ENV === 'production',
  IS_STAGING: SITE_ENV === 'stg',
  IS_PREVIEW: SITE_ENV === 'preview',
  IS_DEVELOPMENT_HOSTING: SITE_ENV === 'development',
  SITE_URL,
  CONTACT_FORM_MODE: resolveContactFormMode(),
  STG_AUTH_ENABLED,
  STG_AUTH_ALLOWED_DOMAINS: parseAllowedDomains(
    process.env.REACT_APP_STG_AUTH_ALLOWED_DOMAINS
  ),
  STG_AUTH_ALLOWED_EMAILS: parseCommaSeparatedValues(
    process.env.REACT_APP_STG_AUTH_ALLOWED_EMAILS
  ),
  FIREBASE_AUTH: {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY || '',
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || '',
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || '',
    appId: process.env.REACT_APP_FIREBASE_APP_ID || '',
  },
};

export const SEO_ENVIRONMENT = {
  ROBOTS_CONTENT: resolveRobotsContent(),
  SHOULD_INDEX: SITE_ENV === 'production',
};
